// extracted by mini-css-extract-plugin
export default {"filtersList":"stock-filter-pill-button-module__filtersList--UbboW"};